import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GalleryDto } from '@nusign/picflow-backend-types';
import { GalleryContextMenuComponent } from '../../../gallery-context-menu/gallery-context-menu.component';
import { GalleryService } from '../../../services/gallery.service';
import { RelativeTimePipe } from '../../../shared-extra/pipes/relative-time.pipe';
import { RemoveIdPrefix } from '../../../shared-extra/pipes/remove-id-prefix.pipe';
import { ContextMenuComponent } from '../../../shared/components/context-menu/context-menu.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { InferredHoverDirective } from '../../../shared/directives/inferred-hover.directive';
import { TooltipDirective } from '../../../shared/directives/tooltip.directive';
import { GalleryTeaserUrlPipe } from '../../../shared/pipes/gallery-teaser-url.pipe';

@Component({
  selector: 'app-gallery-list-item',
  templateUrl: './gallery-list-item.component.html',
  styleUrls: ['./gallery-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterLink,
    InferredHoverDirective,
    TooltipDirective,
    ButtonDirective,
    SvgComponent,
    ContextMenuComponent,
    GalleryContextMenuComponent,
    RelativeTimePipe,
    GalleryTeaserUrlPipe,
    RemoveIdPrefix,
  ],
})
export class GalleryListItemComponent {
  private galleryService = inject(GalleryService);
  readonly gallery = input.required<GalleryDto>();
  readonly link = input<string>();
  readonly target = input<string>('');
  readonly publicMode = input<boolean>();
  readonly dateMode = input<'created_at' | 'last_changed_at'>(undefined);

  async toggleFavorite(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.gallery().is_favourite) {
      await this.galleryService.unFavoriteGallery(this.gallery());
    } else {
      await this.galleryService.favoriteGallery(this.gallery());
    }
  }
}
